import {
  GET_PROVENANCE,
  GET_PROVENANCE_SUCCESS,
  GET_PROVENANCE_FAIL,
} from '../constants/types';

const initState = {
  loading: false,
  data: '',
  error: '',
};

const provenance = (state = initState, action) => {
  switch (action.type) {
    case GET_PROVENANCE:
      return {
        ...state,
        loading: true,
      };
    case GET_PROVENANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data,
        error: '',
      };
    case GET_PROVENANCE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        data: '',
      };
    default:
      return state;
  }
};

export default provenance;
